import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CustomerVerificationService } from './customer-verification.service';

@Injectable({
  providedIn: 'root'
})
export class OrderAppCustomerGuard implements CanActivate {
  errorMsg = 'Unautorisierter Zugriff. Bitte versuchen Sie es später erneut.';

  constructor(
    private customerVerificationService: CustomerVerificationService, private router: Router
  ) { }

  canActivate(): Observable<boolean> {
    const offerId = sessionStorage.getItem('offerId');
    const accessCode = sessionStorage.getItem('accessCode');

    if (!offerId || !accessCode) {
      console.warn("Invalid access link!")
      this.redirectUnauthorizePage(this.errorMsg);
    } else {
      if (!this.customerVerificationService.isVerified(+offerId, accessCode)) {
        this.redirectUnauthorizePage(this.errorMsg);
        return of(false);
      }
    }

    return of(true);
  }

  private redirectUnauthorizePage(errorMsg: string) {
    this.router.navigate(['/bestellung/unauthorized'], { state: { errorMsg } });
  }
}
